import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '../../icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  selector: 'ui-base-card-icon',
  template: `
    <div class="flex items-center justify-center relative w-11 h-11">
      <ui-icon
        [icon]="icon()!"
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-2xl"
        [class]="iconClasses()!"
      />
      <div class="min-w-11 h-11 bg-[#F5F7F9] rounded-full"></div>
    </div>
  `,
})
export class BaseCardIconComponent {
  icon = input<string>();
  iconClasses = input<string | undefined>('text-tertiary');
}
